import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-12 w-full rounded-lg border border-[#E5E5E5] bg-[#F5F5F5] px-4 text-base text-[#1A1A1A] placeholder:text-[#666666] focus:outline-none focus:border-[#CCCCCC] focus:bg-white disabled:cursor-not-allowed disabled:bg-[#FAFAFA] disabled:text-[#999999] file:border-0 file:bg-transparent file:text-sm file:font-medium transition-colors",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
